import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file-request/_file-request')({});
